import React, { useEffect, useState } from "react";
import { graphql, useStaticQuery, navigate } from "gatsby";
import { useLocation } from "@reach/router";

import {
  getInitialLocale,
  setStoredLocale,
  supportedLanguages,
  type SupportedLocale,
} from "../../utils/i18n";

import "./LanguageSwitcher.scss";



export default function LanguageSwitcher() {


  const location = useLocation();


  const [locale, setLocale] =
    useState<SupportedLocale>("en");


  const [open, setOpen] =
    useState(false);


  useEffect(() => {

    setLocale(
      getInitialLocale()
    );

  }, []);




  const data = useStaticQuery(graphql`

    query LanguageSwitcherQuery {

      allMarkdownRemark {

        nodes {

          frontmatter {

            locale

            translationKey

            slug

            type

          }


        }


      }


      site {


        siteMetadata {


          siteUrl


        }


      }


    }


  `);







  const currentPage =
    data.allMarkdownRemark.nodes.find(
      (node:any)=>

        location.pathname.includes(
          node.frontmatter.slug
        )

    );







const handleChange = (
  nextLocale: SupportedLocale
) => {


  setStoredLocale(nextLocale);

  setLocale(nextLocale);

  setOpen(false);


  const currentPath = window.location.pathname;
  const isHomePage =
    currentPath === "/" ||
    currentPath === "/it/";

  if (isHomePage) {
    window.location.href =
      nextLocale === "it" ? "/it/" : "/";
    return;
  }

  const currentSlug =
    currentPath
      .split("/")
      .filter(Boolean)
      .pop();



  const currentPage =
    data.allMarkdownRemark.nodes.find(
      (node:any) =>
        node.frontmatter.slug === currentSlug
    );



  if(!currentPage){

    window.location.reload();

    return;

  }



  const translatedPage =
    data.allMarkdownRemark.nodes.find(
      (node:any)=>

        node.frontmatter.translationKey ===
        currentPage.frontmatter.translationKey

        &&

        node.frontmatter.locale === nextLocale

    );



  if(translatedPage){


    window.location.href =
      `/${nextLocale}/${translatedPage.frontmatter.slug}/`;


    return;

  }



  window.location.reload();


};








  const currentLanguage =
    supportedLanguages.find(
      (language)=>
        language.code === locale
    );









return (

<div className="languageSwitcher">



<button

className="languageButton"

type="button"

onClick={() => setOpen(!open)}

aria-expanded={open}

>


{currentLanguage?.code.toUpperCase()}


<span className={`arrow ${open ? "open" : ""}`}>

▾

</span>


</button>








{
open && (


<div className="languageMenu">



{
supportedLanguages.map((language)=>(


<button

key={language.code}

type="button"

className={
language.code === locale
?
"active"
:
""
}


onClick={() =>
handleChange(
language.code as SupportedLocale
)
}


>


<span className="code">

{language.code.toUpperCase()}

</span>


<span className="name">

{language.nativeLabel}

</span>


</button>


))

}




</div>


)

}




</div>

);


}